import { z } from 'zod';
import type { VoiceDirection } from '../../../server/src/modules/tts/voice-direction';

export const TRANSFER_FAILURE = '服务器传输失败';
export const PRESET_VOICES = ['mimo_default', '冰糖', '茉莉', '苏打', '白桦', 'Mia', 'Chloe', 'Milo', 'Dean'] as const;
export type TtsMode = 'off' | 'preset' | 'design' | 'clone';
export type VoiceMode = Exclude<TtsMode, 'off'>;
export const MODE_LABELS: Record<TtsMode, string> = { off: '关闭', preset: '预设', design: '设计', clone: '复刻' };
export const preferencesSchema = z.object({
  preset: z.object({ voice: z.enum(PRESET_VOICES) }),
  design: z.object({ description: z.string().max(2000) }),
  clone: z.object({ instruction: z.string().max(2000) }),
});
export type VoicePreferences = z.infer<typeof preferencesSchema>;
export function defaultPreferences(): VoicePreferences {
  return { preset: { voice: 'mimo_default' }, design: { description: '' }, clone: { instruction: '' } };
}
const subscriptionSchema = z.object({ id: z.string(), planId: z.string(), startsAt: z.string(), expiresAt: z.string() });
export const accountSchema = z.object({
  userId: z.string().min(1), active: z.boolean(), expiresAt: z.string().nullable(),
  subscriptions: z.array(subscriptionSchema), preferences: preferencesSchema,
  allowed: z.boolean().optional(),
  quota: z.object({ limit: z.number().nullable(), used: z.number(), remaining: z.number().nullable() }).optional(),
});
export type TtsAccount = z.infer<typeof accountSchema>;
export const planSchema = z.object({
  id: z.string(), label: z.string(), mode: z.enum(['preset', 'design', 'clone']), available: z.boolean(),
});
export type TtsPlan = z.infer<typeof planSchema>;
export const plansSchema = z.object({
  models: z.array(planSchema), voices: z.array(z.enum(PRESET_VOICES)),
  maxReferenceBytes: z.number().int().positive(), maxTextChars: z.number().int().positive(),
});
export type TtsPlans = z.infer<typeof plansSchema>;
export const audioHandleSchema = z.object({
  id: z.string().min(1), sha256: z.string().regex(/^[0-9a-f]{64}$/),
  bytes: z.number().int().positive(), mime: z.literal('audio/wav'),
});
export type AudioHandle = z.infer<typeof audioHandleSchema>;
export interface SynthesisInput {
  mode: VoiceMode; text: string; reference?: string; consent?: true; messageId?: string; voiceDescription?: string;
  autoVoiceDesign?: boolean; voiceDirection?: VoiceDirection;
}
export const purchaseSchema = z.object({ id: z.string(), startsAt: z.string(), expiresAt: z.string() });

export class MimoError extends Error {
  constructor(message: string, readonly status?: number) { super(message); this.name = 'MimoError'; }
}
export function displayMimoError(error: unknown): string {
  return error instanceof MimoError ? error.message : TRANSFER_FAILURE;
}
export const MAX_REFERENCE_BYTES = 7 * 1024 * 1024;
